import {get} from "lodash"

const getPrivateQuestionGroupFromCycle = (cycle) => {
  const groups = get(cycle, "questionGroups.results") || []
  const privateGroup = groups.find(({tenantUuid}) => tenantUuid !== null)
  return privateGroup ? privateGroup.uuid : null
}

export default getPrivateQuestionGroupFromCycle
